/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {
    AfterContentChecked,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DoCheck,
    ElementRef,
    NgZone
} from '@angular/core';
import { ReportContentContainerComponent } from './report-content-container.component';
import { LoggerService } from '../../shared/services/logger.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DataFormService } from '../services/dataform.service';
import { ReportService } from '../services/report.service';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { UntypedFormBuilder } from '@angular/forms';
import { IsolatedReportService } from '../services/isolatedReport.service';
import { DeviceService } from '../../shared/services/device.service';

@Component({
    selector: 'dash-gis-report-content-print',
    templateUrl: './report-content-container-print.component.html',
    styleUrls: ['./report-content-container.component.scss', './report-content-container-print.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportContentContainerPrintComponent extends ReportContentContainerComponent implements DoCheck {
    constructor(
        logger: LoggerService,
        ngZone: NgZone,
        sanitizer: DomSanitizer,
        reportService: ReportService,
        isolatedReportService: IsolatedReportService,
        dataFormService: DataFormService,
        deviceService: DeviceService,
        dialog: MatDialog,
        store: Store,
        el: ElementRef,
        fb: UntypedFormBuilder,
        cd: ChangeDetectorRef
    ) {
        super(
            logger,
            ngZone,
            sanitizer,
            reportService,
            isolatedReportService,
            dataFormService,
            deviceService,
            dialog,
            store,
            el,
            fb,
            cd
        );
    }

    ngDoCheck() {
        super.ngDoCheck();
    }
}
